import type { ServiceEventType } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): Record<ServiceEventType, string> => {
    const t = useTranslate('serviceLogEntry');

    return {
        CALIBRATED: t('calibrated'),
        INSPECTED: t('inspected'),
        REPLACED: t('replaced'),
        SERVICED: t('serviced')
    };
};

export default useTranslation;
